import React from 'react';

const MonthlySoldItems = ({ endDate, startDate, resPacket }) => {

    const getMonthNamesBetween = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const result = [];

        const current = new Date(start.getFullYear(), start.getMonth(), start.getDate());

        while (current <= end) {
            const monthYear = current.toLocaleString("default", { month: "short", year: "numeric" });
            result.push(monthYear);
            current.setMonth(current.getMonth() + 1);
        }

        return result;
    };

    const getThisMonthSales = (monthYear, sales) => {
        const [monthName, year] = monthYear.split(" ");
        const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth() + 1;
        const monthNum = monthIndex.toString().padStart(2, '0');
        const matchingKey = Object.keys(sales).find(key => key.endsWith(`-${monthNum}`));

        return matchingKey ? sales[matchingKey] : 0;
    };

    return (
        <div className="customTable" id="scroll">
            {resPacket && resPacket.length > 0 ? (
                <table className="customTable w-100">
                    <thead className="fixed-thead">
                        <tr>
                            <td>Item Name</td>
                            <td>Pack Unit Title</td>

                            {getMonthNamesBetween(startDate, endDate).map((e, i) => (
                                <td key={i}><b>{e}</b></td>
                            ))}

                            <td style={{ marginLeft: 10 }}><b>{"     "}Total </b></td>
                        </tr>
                    </thead>
                    <tbody className="body-scroll-custom">
                        {resPacket.map((sale, i) => (
                            <tr key={i}>
                                <td>{sale?.itemTitle}</td>
                                <td>{sale.uom}</td>
                                {getMonthNamesBetween(startDate, endDate).map((e, i) => (
                                    <td style={{ width: "95px", marginLeft: "5px" }} key={i}>{getThisMonthSales(e, sale.monthlySales)}</td>
                                ))}
                                <td>
                                    <b>{parseFloat(Object.values(sale.monthlySales).reduce((acc, item) => acc + item, 0)).toFixed(2)}</b>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div>No Records Available</div>
            )}
        </div>
    );
};

export default MonthlySoldItems;
